/**
 * Flint Featured Products Carousel
 * - Manually initializes Flickity for full control
 * - Handles custom arrows and sort functionality
 */

(function() {
  'use strict';

  // Flickity configuration (same as flint-col-showcase)
  const FLICKITY_CONFIG = {
    cellAlign: 'left',
    contain: true,
    wrapAround: false,
    freeScroll: true,
    prevNextButtons: false,
    pageDots: false,
    draggable: true,
    groupCells: true,
    imagesLoaded: true,
    lazyLoad: 2,
    friction: 0.28,
    selectedAttraction: 0.04,
    freeScrollFriction: 0.075
  };

  function initFeaturedProducts(section) {
    const carousel = section.querySelector('[data-carousel]');
    if (!carousel) return;

    let flkty = null;

    // Initialize Flickity
    function initFlickity() {
      // Destroy existing if present
      if (flkty) {
        flkty.destroy();
      }
      
      // Create new Flickity instance
      flkty = new Flickity(carousel, FLICKITY_CONFIG);
      
      // Set up custom arrows
      setupArrows();
    }

    // Set up custom arrow buttons
    function setupArrows() {
      const prevBtn = section.querySelector('.flint-featured__arrow--prev');
      const nextBtn = section.querySelector('.flint-featured__arrow--next');

      // Remove old listeners by cloning
      if (prevBtn) {
        const newPrevBtn = prevBtn.cloneNode(true);
        prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
        newPrevBtn.addEventListener('click', () => flkty.previous());
      }
      
      if (nextBtn) {
        const newNextBtn = nextBtn.cloneNode(true);
        nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);
        newNextBtn.addEventListener('click', () => flkty.next());
      }

      // Update arrow states
      const updateArrows = () => {
        const currentPrev = section.querySelector('.flint-featured__arrow--prev');
        const currentNext = section.querySelector('.flint-featured__arrow--next');
        if (currentPrev) currentPrev.disabled = flkty.selectedIndex === 0;
        if (currentNext) currentNext.disabled = flkty.selectedIndex === flkty.slides.length - 1;
      };

      flkty.off('select', updateArrows);
      flkty.on('select', updateArrows);
      updateArrows();
    }

    // Wait for Flickity library to load
    function waitForFlickity(callback) {
      if (typeof Flickity !== 'undefined') {
        callback();
      } else {
        setTimeout(() => waitForFlickity(callback), 50);
      }
    }

    // Sort functionality
    function setupSort() {
      const sortSelect = section.querySelector('.flint-featured__sort-select');
      if (!sortSelect) return;

      // Remove old listeners by cloning
      const newSortSelect = sortSelect.cloneNode(true);
      sortSelect.parentNode.replaceChild(newSortSelect, sortSelect);

      newSortSelect.addEventListener('change', () => {
        const sortBy = newSortSelect.value;
        const sectionId = section.dataset.sectionId;
        const collectionHandle = section.dataset.collectionHandle || 'all';
        const url = `/collections/${collectionHandle}?sort_by=${sortBy}&section_id=${sectionId}`;
        
        fetch(url)
          .then(r => r.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newCarousel = doc.querySelector('[data-carousel]');
            if (newCarousel && carousel) {
              // Destroy existing Flickity
              if (flkty) {
                flkty.destroy();
                flkty = null;
              }
              
              // Replace carousel HTML
              carousel.innerHTML = newCarousel.innerHTML;
              
              // Re-initialize Flickity
              waitForFlickity(() => {
                initFlickity();
              });
            }
          })
          .catch(error => {
            console.error('Error updating sort:', error);
          });
      });
    }

    // Initialize
    waitForFlickity(() => {
      initFlickity();
      setupSort();
    });
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.flint-featured-products').forEach(initFeaturedProducts);
  });

  // Handle Shopify section editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.flint-featured-products');
      if (section) {
        initFeaturedProducts(section);
      }
    });
  }
})();
